import "../css/App.css";

import React, { useEffect, useMemo, useRef } from "react";

export default function CrashHistoryRow({ crashHistory }) {
  const items = useMemo(
    () => [...crashHistory].slice(0).reverse(),
    [crashHistory],
  );

  const viewportRef = useRef(null);
  const trackRef = useRef(null);
  const firstItemRef = useRef(null);

  const didMountRef = useRef(false);

  useEffect(() => {
    // ✅ prevents the “on refresh” double animation
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    const viewport = viewportRef.current;
    const track = trackRef.current;
    const firstItem = firstItemRef.current;
    if (!viewport || !track || !firstItem) return;

    viewport.scrollLeft = 0;

    const gap = 6;
    const shift = firstItem.offsetWidth + gap;
    track.style.setProperty("--shift", `${shift}px`);

    track.classList.remove("row-shift");
    void track.offsetWidth;
    track.classList.add("row-shift");

    firstItem.classList.remove("is-entering");
    void firstItem.offsetWidth;
    firstItem.classList.add("is-entering");
  }, [crashHistory]);

  return (
    <div ref={viewportRef} className="crash-row-viewport">
      <ul ref={trackRef} className="crash-row-track">
        {items.map((item, index) => (
          <li
            key={`${item}-${index}`}
            ref={index === 0 ? firstItemRef : null}
            className={`select-none crash-item ${item >= 2 ? "table-row-blue" : "table-row-red"}`}
          >
            {item}x
          </li>
        ))}
      </ul>
    </div>
  );
}
